/* GSLION — product.js (PDP only)
   Native variant <select> drives state. Radios proxy clicks. */
(() => {
  'use strict';
  const pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  const $ = (s, r = pdp) => r.querySelector(s);
  const $$ = (s, r = pdp) => Array.from(r.querySelectorAll(s));

  const form         = $('[data-pdp-form]');
  const variantSel   = $('[data-variant-select]');
  const priceWrap    = $('[data-price-wrap]');
  const atcBtn       = $('[data-atc]');
  const atcLabel     = $('[data-atc-label]');
  const variants     = JSON.parse($('[data-product-json]').textContent);

  const money = c => {
    const dollars = (c / 100);
    return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
  };

  /* ---------- Variant selection ---------- */
  $$('[data-option-input]').forEach(input => {
    input.addEventListener('change', () => {
      const opts = $$('[data-option-input]:checked').map(i => i.value);
      const match = variants.find(v => v.options.every((opt, i) => opt === opts[i]));
      if (match) {
        variantSel.value = match.id;
        applyVariant(match);
      }
      syncSwatchUI();
      syncAvailability();
    });
  });

  function syncSwatchUI() {
    $$('.pdp__swatch').forEach(sw => {
      const input = sw.querySelector('input');
      sw.classList.toggle('is-active', input.checked);
    });
    // Update selected text in legend
    $$('[data-option-position]').forEach(input => {
      if (input.tagName !== 'INPUT') return;
      if (!input.checked) return;
      const pos = input.dataset.optionPosition;
      const target = $(`[data-option-selected="${pos}"]`);
      if (target) target.textContent = input.value;
    });
  }

  /* Availability sync (multi-option safe).
     For each option value, decide if ANY variant is available that
     combines this value with the currently-selected values of the
     OTHER options. Single-option products: this reduces to "is any
     variant with this value available", matching the server render. */
  function syncAvailability() {
    const groups = $$('.pdp__option');
    if (!groups.length) return;
    const selected = groups.map(g => {
      const checked = g.querySelector('[data-option-input]:checked');
      return checked ? checked.value : null;
    });

    groups.forEach((group, gi) => {
      group.querySelectorAll('.pdp__swatch').forEach(sw => {
        const input = sw.querySelector('input');
        if (!input) return;
        const candidate = selected.slice();
        candidate[gi] = input.value;
        const exists = variants.some(v =>
          v.available &&
          v.options.every((opt, i) => candidate[i] == null || opt === candidate[i])
        );
        input.disabled = !exists;
        sw.classList.toggle('is-sold', !exists);
        // Never strike the value the customer currently has selected.
        if (input.checked) sw.classList.remove('is-sold');
      });
    });
  }

  function applyVariant(v) {
    // Price
    let html;
    if (v.compare_at_price && v.compare_at_price > v.price) {
      html = `<span class="pdp__price-sale" data-price>${money(v.price)}</span>
              <span class="pdp__price-compare" data-compare>${money(v.compare_at_price)}</span>`;
    } else {
      html = `<span data-price>${money(v.price)}</span>`;
    }
    priceWrap.innerHTML = html;

    // ATC
    atcBtn.disabled = !v.available;
    atcLabel.innerHTML = v.available
      ? `Add to cart · ${money(v.price)}`
      : 'Sold out';

    // URL
    const u = new URL(window.location);
    u.searchParams.set('variant', v.id);
    history.replaceState({}, '', u);

    // Notify sticky bar
    document.dispatchEvent(new CustomEvent('gs:variant', { detail: v }));
  }

  /* Initial availability pass (keeps first render consistent with JS). */
  syncAvailability();

  /* ---------- Quantity ---------- */
  const qty = $('[data-qty]');
  if (qty) {
    const input = qty.querySelector('input');
    qty.addEventListener('click', e => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyChange, 10));
      input.value = next;
    });
  }

  /* ---------- Gallery: scroll-based dot sync ---------- */
  const galMain = $('[data-gal-main]');
  const dots = $$('.pdp-gal__dots span');
  if (galMain && dots.length > 1 && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          const i = parseInt(en.target.dataset.galSlide, 10);
          dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
        }
      });
    }, { root: galMain, threshold: 0.6 });
    $$('[data-gal-slide]').forEach(s => io.observe(s));
  }

  /* ---------- AJAX ATC ---------- */
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (atcBtn.disabled) return;
    const original = atcLabel.innerHTML;
    atcLabel.textContent = 'Adding…';
    atcBtn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!r.ok) throw new Error('add_failed');
      await window.theme?.refreshCart?.();
      window.theme?.openDrawer?.(window.theme.cartDrawer);
      atcBtn.classList.add('is-added');
      atcLabel.textContent = '✓ Added';
      setTimeout(() => {
        atcBtn.classList.remove('is-added');
        atcLabel.innerHTML = original;
        atcBtn.disabled = false;
      }, 1400);
    } catch (_) {
      atcLabel.textContent = 'Try again';
      setTimeout(() => { atcLabel.innerHTML = original; atcBtn.disabled = false; }, 1500);
    }
  });

  /* ---------- Sticky ATC ---------- */
  const satc = document.querySelector('[data-satc]');
  if (satc && atcBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const shouldShow = !entry.isIntersecting && window.scrollY > 300;
      satc.classList.toggle('is-visible', shouldShow);
    }, { rootMargin: '-80px 0px -80px 0px' });
    io.observe(atcBtn);

    const satcBtn   = satc.querySelector('[data-satc-add]');
    const satcVar   = satc.querySelector('[data-satc-variant]');
    const satcPrice = satc.querySelector('[data-satc-price]');

    satcBtn.addEventListener('click', () => {
      const sizeFs = $$('.pdp__option').find(fs =>
        (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('size')
      );
      if (sizeFs && !sizeFs.querySelector('input:checked')) {
        sizeFs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      atcBtn.click();
    });

    document.addEventListener('gs:variant', e => {
      const v = e.detail;
      if (satcVar) satcVar.textContent = v.title;
      if (satcPrice) satcPrice.textContent = money(v.price);
      satcBtn.disabled = !v.available;
      satcBtn.textContent = v.available ? 'Add' : 'Sold out';
    });

    // Hide sticky when cart drawer opens
    const cd = document.querySelector('[data-drawer="cart"]');
    if (cd) {
      new MutationObserver(() => {
        satc.classList.toggle('is-hidden', cd.classList.contains('is-open'));
      }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
  }
})();
